import { status } from 'skin/event/status';

const def = (obj, ms, story, d, action) => {
	console.log('[def мастер] событие', obj);
	return status.action;
};

export default def;
